import { query_string, isVkPlay, isAstrum } from '@platform/shared';

const baseUrl = process.env.VUE_APP_PUBLIC_PATH;

const { no_gem } = query_string();

export const isReadMode = window.location.pathname.indexOf('/gameterms/') > -1 || !!no_gem;

const LANG_COOKIE = 'amc_lang';

export const changeCookieLanguage = (language = 'en_US') => {
  const expired = new Date(new Date().setFullYear(new Date().getFullYear() + 1));

  $cookies.set(LANG_COOKIE, language, expired, '/', '.my.games');
};

let PROJECT;

if (isVkPlay) {
  PROJECT = 'vkplay';
} else if (isAstrum) {
  PROJECT = 'astrum';
} else {
  PROJECT = 'mygames';
}

const PAGE_NAMES_BY_PROJECT = {
  vkplay: 'VK Play',
  astrum: 'Astrum',
  mygames: 'MY.GAMES',
};

const PAGE_LINKS_BY_PROJECT = {
  vkplay: [
    {
      rel: 'shortcut icon',
      href: `${baseUrl}image/favicon/vk_favicon.ico`,
    },
  ],
  astrum: [
    {
      rel: 'shortcut icon',
      href: `${baseUrl}image/favicon/astrum_favicon.ico`,
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '192x192',
      href: `${baseUrl}image/favicon/astrum_android-icon-192x192.png`,
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '32x32',
      href: `${baseUrl}image/favicon/astrum_favicon-32x32.png`,
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '96x96',
      href: `${baseUrl}image/favicon/astrum_favicon-96x96.png`,
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '16x16',
      href: `${baseUrl}image/favicon/astrum_favicon-16x16.png`,
    },
  ],
  mygames: [
    {
      rel: 'icon',
      type: 'image/x-icon',
      href: `${baseUrl}image/favicon/favicon.ico`,
    },
    {
      rel: 'apple-touch-icon',
      sizes: '57x57',
      href: `${baseUrl}image/favicon/apple-icon-57x57.png`,
    },
    {
      rel: 'apple-touch-icon',
      sizes: '60x60',
      href: `${baseUrl}image/favicon/apple-icon-60x60.png`,
    },
    {
      rel: 'apple-touch-icon',
      sizes: '72x72',
      href: `${baseUrl}image/favicon/apple-icon-72x72.png`,
    },
    {
      rel: 'apple-touch-icon',
      sizes: '76x76',
      href: `${baseUrl}image/favicon/apple-icon-76x76.png`,
    },
    {
      rel: 'apple-touch-icon',
      sizes: '114x114',
      href: `${baseUrl}image/favicon/apple-icon-114x114.png`,
    },
    {
      rel: 'apple-touch-icon',
      sizes: '120x120',
      href: `${baseUrl}image/favicon/apple-icon-120x120.png`,
    },
    {
      rel: 'apple-touch-icon',
      sizes: '144x144',
      href: `${baseUrl}image/favicon/apple-icon-144x144.png`,
    },
    {
      rel: 'apple-touch-icon',
      sizes: '152x152',
      href: `${baseUrl}image/favicon/apple-icon-152x152.png`,
    },
    {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: `${baseUrl}image/favicon/apple-icon-180x180.png`,
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '192x192',
      href: `${baseUrl}image/favicon/android-icon-192x192.png`,
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '32x32',
      href: `${baseUrl}image/favicon/favicon-32x32.png`,
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '96x96',
      href: `${baseUrl}image/favicon/favicon-96x96.png`,
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '16x16',
      href: `${baseUrl}image/favicon/favicon-16x16.png`,
    },
    {
      rel: 'icon',
      sizes: '16x16',
      href: `${baseUrl}image/favicon/favicon-16x16.ico`,
    },
    {
      rel: 'manifest',
      href: `${baseUrl}image/favicon/manifest.json`,
    },
  ],
};

const PAGE_META_BY_PROJECT = {
  vkplay: [],
  astrum: [],
  mygames: [
    {
      name: 'msapplication-TileColor',
      content: '#ffffff',
    },
    {
      name: '',
      content: `${baseUrl}image/favicon/ms-icon-144x144.png`,
    },
  ],
};

export const PAGE_NAME = PAGE_NAMES_BY_PROJECT[PROJECT];
export const PAGE_LINKS = PAGE_LINKS_BY_PROJECT[PROJECT];
export const PAGE_META = PAGE_META_BY_PROJECT[PROJECT];
